module.exports = __webpack_public_path__ + "static/instagram-icon-4052bbff6443f8461d1665ec7d8c2f67.png";